import React from 'react';
import classNames from 'classnames';
import LazyloadImage from '../sharedComponents/LazyloadImage';

import './video.scss';

const headlineClasses = classNames(
    'eds-g-cell',
    'eds-g-cell-12-12',
    'eds-g-offset-0-12',
    'eds-g-cell-md-8-12',
    'eds-g-offset-md-2-12',
    'eds-g-offset-md-2-12',
    'eds-g-cell-lg-6-12',
    'eds-g-offset-lg-3-12',
);

const videoClasses = classNames(
    'eds-g-cell',
    'eds-g-cell-12-12',
    'eds-g-offset-0-12',
    'eds-g-cell-md-10-12',
    'eds-g-offset-md-1-12',
    'eds-l-mar-top-14',
    'eds-g-cell--has-overflow',
);

const playButtonIcon =
    'https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/on-demand-video/play_large_icon.svg';

interface VideoProps {
    tagline: string;
    headline: string;
    description: string;
    video: string;
    backgroundImage: string;
}
const VideoModule = ({
    tagline,
    headline,
    description,
    video,
    backgroundImage,
}: VideoProps) => (
    <React.Fragment>
        <section className="eds-bg-color--white mktg-top-p-180">
            <div className="marketing-container__max-width eds-l-pad-hor-6">
                <div className="eds-g-grid">
                    <div className="eds-l-mar-top-6">
                        <div className={headlineClasses}>
                            <p className="eds-text-color--ui-orange eds-text-bl mktg-text-weight--heavy eds-text--center">
                                {tagline}
                            </p>
                            <h2 className="eds-text-color--grey-900 mktg-h1 mktg-text-weight--heavy eds-text--center  eds-l-mar-top-6">
                                {headline}
                            </h2>
                            <div
                                className="eds-text-color--grey-700 eds-text-bl eds-text-weight--regular eds-l-mar-top-6  eds-text--center"
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div className="marketing-container__max-width eds-l-pad-hor-6">
                <div className="eds-g-grid">
                    <div className={videoClasses}>
                        <div className="mktg-video-card mktg-video-card_hero mktg-shadow-primary">
                            <a
                                href={video}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mfp-video js-d-modal"
                                data-d-modal-options='{
                                    "disableOn": 700,
                                    "type": "iframe",
                                    "mainclassName":
                                    "mfp-fade",
                                    "removalDelay": 160,
                                    "preloader": false,
                                    "fixedContentPos": false
                                }'
                            >
                                <div className="mktg-video-card__header">
                                    <div
                                        className="mktg-video-card__image"
                                        style={{
                                            backgroundImage: `url(${backgroundImage})`,
                                            backgroundPosition: 'center',
                                        }}
                                    >
                                        <LazyloadImage
                                            image={playButtonIcon}
                                            classes=""
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </React.Fragment>
);
export default VideoModule;
